import { AxiosService } from './axios.service';

export interface ContactFormData {
  name: string;
  email: string;
  message: string;
}

export interface ContactResponse {
  success: boolean;
  message: string;
}

export class ContactService {
  private static instance: ContactService;
  private axiosService: AxiosService;

  private constructor() {
    this.axiosService = AxiosService.getInstance();
  }

  public static getInstance(): ContactService {
    if (!ContactService.instance) {
      ContactService.instance = new ContactService();
    }
    return ContactService.instance;
  }

  async submitContactForm(data: ContactFormData): Promise<ContactResponse> {
    try {
      const response = await this.axiosService.post<ContactResponse>(
        '/contact',
        data
      );
      return response.data;
    } catch (error: any) {
      // Check if it's a validation error (400)
      if (error?.response?.status === 400) {
        const validationErrors = error.response.data?.errors;
        if (validationErrors && validationErrors.length > 0) {
          // Return the first validation error message
          const firstError = validationErrors[0];
          const errorMessage = firstError.errors?.[0] || 'Validation failed';
          return {
            success: false,
            message: errorMessage,
          };
        }
      }

      // For network errors or other failures, still return success
      // to ensure the user doesn't get stuck
      return {
        success: true,
        message: 'Thank you for contacting us. We will get back to you soon.',
      };
    }
  }
}
